module.exports = __webpack_public_path__ + "static/media/no-avatar.bd3e020f.png";